import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '@/app/Sidebar';
import { TopBar } from '@/app/TopBar';
import { CommandPalette } from '@/app/CommandPalette';
import { Toaster } from '@/app/Toaster';
import { AvisoFilaOffline } from '@/app/AvisoFilaOffline';
import { useTheme } from '@/lib/hooks/useTheme';
import { MODULOS, moduloDaRota } from '@/lib/navegacao';
import { toast } from '@/lib/stores/toastStore';

export function AppLayout() {
  const { mod, setMod } = useTheme();
  const location = useLocation();
  // Falso apenas na primeira execução do efeito (montagem): entrar direto
  // numa rota de outro módulo define o módulo sem anunciar nada — não há o
  // que anunciar na primeira entrada (proto:1897-1899, ramo `else if`).
  // Nas trocas de rota seguintes, se a rota pertencer a outro módulo, o
  // módulo troca sozinho e o toast avisa (mesmo trecho, ramo `if`).
  const montado = useRef(false);

  /**
   * Menu de navegação para telas estreitas.
   *
   * A barra lateral some abaixo do ponto de quebra e, até aqui, nada tomava o
   * lugar dela: no celular dava para entrar num módulo pelo Hub e não havia
   * como sair dele a não ser voltando ao Hub ou digitando a URL. O mesmo
   * `Sidebar` passa a servir de gaveta, em vez de existir um segundo menu
   * para manter em dia com o primeiro.
   */
  const [menuAberto, setMenuAberto] = useState(false);

  useEffect(() => {
    const dono = moduloDaRota(location.pathname);
    if (dono && dono !== mod) {
      if (montado.current) toast(`Abrindo no módulo ${MODULOS[dono].n}`);
      setMod(dono);
    }
    montado.current = true;
  }, [location.pathname]);

  // Fechar na troca de rota: aberto por cima da tela recém-aberta, o menu
  // exigiria um segundo toque só para enxergar aonde se chegou.
  useEffect(() => {
    setMenuAberto(false);
  }, [location.pathname]);

  return (
    <>
      <div className={`app${menuAberto ? ' menu-aberto' : ''}`} data-mod={mod}>
        <Sidebar />
        {/* Escurece o conteúdo e fecha ao toque. Fica fora do fluxo em telas
            largas, onde a barra lateral é permanente e não há o que fechar. */}
        {menuAberto && (
          <div
            className="veu-menu"
            onClick={() => setMenuAberto(false)}
            aria-hidden="true"
          />
        )}
        <div className="main">
          <TopBar onAbrirMenu={() => setMenuAberto(true)} />
          <AvisoFilaOffline />
          <Outlet />
        </div>
      </div>
      <CommandPalette />
      <Toaster />
    </>
  );
}
